import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Table, TableBody,
  TableCell, TableContainer,
  TableHead, TableSortLabel,
  TableRow, Button, withStyles,
  Paper, Toolbar, Typography, Tooltip,
  IconButton,
  Checkbox,
} from '@material-ui/core';
import {
  Close as CloseIcon,
} from '@material-ui/icons';
import Pagination from '../../../components/atoms/pagination/Pagination';
import { getComparator, stableSort } from '../../../helpers/tableSort.helper';
import ConfirmDialog from '../../../components/templates/confirmDialog/ConfirmDialog';
import urls from '../../../constants/urls';

const styles = () => ({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  highlight: {
    backgroundColor: '#E8F0FE',
  },
  title: {
    flex: '1 1 50%',
  },
  tableLabel: {
    verticalAlign: 'baseline',
  },
  emptyTableCell: {
    textAlign: 'center',
  },
  downloadRoot: {
    marginRight: '10px',
  },
});

class MailMagazineListDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.headCells = [
      { id: 'store', numeric: false, label: '店舗' },
      { id: 'title', numeric: false, label: 'タイトル' },
      { id: 'status', numeric: false, label: 'ステータス' },
      { id: 'send_at', numeric: false, label: '送信日時' },
    ];

    this.state = {
      order: 'asc',
      orderBy: '',
      selected: [],
      isDeleteOpen: false,
      loading: false,
    };
  }

  handleRequestSort = (_, property) => {
    const { order, orderBy } = this.state;

    const isAsc = orderBy === property && order === 'asc';

    this.setState({ order: isAsc ? 'desc' : 'asc', orderBy: property });
  };

  createSortHandler = (property) => (event) => {
    this.handleRequestSort(event, property);
  };

  handleHeaderClose = () => {
    this.setState({ selected: [] });
  };

  onDelete = () => {
    this.setState({ isDeleteOpen: true });
  }

  onDeleteClose = () => {
    this.setState({ isDeleteOpen: false });
  }

  onDeleteData = () => {
    const { selected: ids } = this.state;
    this.setState({ selected: [], isDeleteOpen: false });
    this.props.onDelete({ ids });
  }

  getTableHeadCell = (headCell) => {
    const { isMain, classes } = this.props;
    const { order, orderBy } = this.state;
    if (headCell.id === 'store' && !isMain) {
      return null;
    }
    return (
      <TableCell
        key={headCell.id}
        align="left"
        padding="default"
        sortDirection={orderBy === headCell.id ? order : false}
      >
        <TableSortLabel
          active={orderBy === headCell.id}
          direction={orderBy === headCell.id ? order : 'asc'}
          onClick={this.createSortHandler(headCell.id)}
          className={classes.tableLabel}
        >
          {headCell.label}
          {orderBy === headCell.id ? (
            <span className={classes.visuallyHidden}>
              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
            </span>
          ) : null}
        </TableSortLabel>
      </TableCell>
    );
  }

  isSelected = (rowId) => this.state.selected.includes(rowId);

  handleClick = (_, rowId) => {
    const { selected: rowIds } = this.state;
    const selectedIndex = rowIds.indexOf(rowId);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(rowIds, rowId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(rowIds.slice(1));
    } else if (selectedIndex === rowIds.length - 1) {
      newSelected = newSelected.concat(rowIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        rowIds.slice(0, selectedIndex),
        rowIds.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleSelectAllClick = () => {
    const { selected: rowIds, order, orderBy } = this.state;
    const { datas } = this.props;
    const tableDatas = stableSort(datas, getComparator(order, orderBy));
    let selectedData = [];
    if (rowIds.length !== tableDatas.length) {
      const newSelecteds = tableDatas.map((scr) => scr.id);
      selectedData = newSelecteds;
    }

    this.setState({ selected: selectedData });
  };

  onAdd = () => {
    const url = urls.SETTING.MAIL_MAGAZINE_ENTRY;
    this.props.history.push({ pathname: url });
  }

  render() {
    const {
      classes,
      datas,
      totalElements,
      rowsPerPage,
      page,
      onChangePage,
      onChangeRowsPerPage,
      onClick,
      isMain,
    } = this.props;

    const {
      order, orderBy, selected, isDeleteOpen, loading,
    } = this.state;

    return (
      <Paper>
        <Toolbar className={selected.length > 0 ? classes.highlight : ''}>
          {selected.length > 0 ? (
            <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
              <IconButton aria-label="delete" size="medium" onClick={this.handleHeaderClose}>
                <CloseIcon fontSize="inherit" />
              </IconButton>
              {selected.length}
              {' '}
              件選択中
            </Typography>
          ) : (
            <Typography className={classes.title} color="inherit" variant="subtitle1" component="div" />
          )}
          {selected.length === 0 && (
            <div>
              <Tooltip title="メールマガジンの追加">
                <Button color="primary" onClick={this.onAdd}>メールマガジンの追加</Button>
              </Tooltip>
            </div>
          )}
          {selected.length > 0 && (
          <Tooltip title="メールマガジンの削除">
            <Button color="secondary" onClick={this.onDelete}>メールマガジンの削除</Button>
          </Tooltip>
          )}
        </Toolbar>
        <TableContainer>
          <Table
            aria-labelledby="tableTitle"
            size="medium"
            aria-label="enhanced table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                <TableCell align="center" padding="checkbox">
                  {' '}
                  <Checkbox
                    onClick={this.handleSelectAllClick}
                    checked={
                      selected.length > 0
                      && selected.length
                        === stableSort(datas, getComparator(order, orderBy)).length
                    }
                  />
                </TableCell>
                {this.headCells.map((headCell) => this.getTableHeadCell(headCell))}
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {stableSort(datas, getComparator(order, orderBy))
                .map((row) => {
                  const isSelected = this.isSelected(row.id);
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={row.id}
                    >
                      <TableCell role="checkbox">
                        <Checkbox
                          checked={isSelected}
                          inputProps={{ 'aria-labelledby': row.id }}
                          color="primary"
                          onClick={(event) => this.handleClick(event, row.id)}
                        />
                      </TableCell>
                      <TableCell style={{ display: isMain ? '' : 'none' }}>
                        {row.store}
                      </TableCell>
                      <TableCell>
                        {row.title}
                      </TableCell>
                      <TableCell>
                        {row.status}
                      </TableCell>
                      <TableCell>
                        {row.sendAt}
                      </TableCell>
                      <TableCell>
                        <Button color="primary" onClick={(event) => onClick(event, row.id)}>詳細を見る</Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {
                datas.length < 1 && (
                  <TableRow>
                    <TableCell className={classes.emptyTableCell} colSpan={6}>
                      データがありません
                    </TableCell>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination
          totalElements={totalElements}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        />
        <ConfirmDialog
          open={isDeleteOpen}
          handleClose={this.onDeleteClose}
          executeText="削除する"
          handleExecute={this.onDeleteData}
          title="メールマガジンの削除"
          contentText="選択したメールマガジンを削除します。この操作は元に戻すことができません。"
          loading={loading}
          buttonColor="secondary"
        />
      </Paper>
    );
  }
}

MailMagazineListDataTable.propTypes = {
  datas: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
};

export default withStyles(styles)(withRouter(MailMagazineListDataTable));
